module.exports = __webpack_public_path__ + "img/icon_about_12.cc1f6e7b.png";